import React from 'react'
import {Block, Col} from 'jsxstyle'
import {useCopilotContext} from './CopilotContext'
import CopilotConversationRow from './components/CopilotConversationRow'
import i18n from '../../common/i18n'

const ConversationList: React.FC = () => {
  const {conversations, createConversation, setSelectedConversation, deleteConversation} = useCopilotContext()

  const handleNewConversation = async () => {
    const newConv = await createConversation()
    if (newConv) {
      setSelectedConversation(newConv)
    }
  }

  return (
    <Col flex="1" padding="15px" gap="10px" overflow="auto">
      <Block
        backgroundColor="#f0f5ff"
        padding="12px"
        borderRadius="8px"
        marginBottom="10px"
        cursor="pointer"
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="#0070f3"
        fontWeight={500}
        props={{
          onClick: handleNewConversation,
        }}
        hoverBackgroundColor="#e0ebff"
      >
        + {i18n.t('xk.copilot.conversation.new')}
      </Block>

      {conversations.length === 0 ? (
        <Block textAlign="center" color="#666" padding="20px">
          {i18n.t('xk.copilot.conversation.empty')}
        </Block>
      ) : (
        conversations.map((conversation) => (
          <CopilotConversationRow
            key={conversation.id}
            conversation={conversation}
            onSelect={setSelectedConversation}
            onDelete={deleteConversation}
          />
        ))
      )}
    </Col>
  )
}

export default ConversationList
